export default __webpack_public_path__ + "static/media/about2.018f23a6.webp";